import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../../components/forms/ConfirmForm";
import {cancelStartService} from "../../../actions/InfrastructureApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";


class StartServiceFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.startService({serviceId: this.props.serviceId})
      .then((response) => {
        if (response.data.startService.errors.length <= 0) {
          this.props.cancelStartService();
        } else {
          let errors = createValidationErrors(response.data.startService.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelStartService();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to start this service?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const START_SERVICE = gql`
  mutation startService($data: InfrastructureStartServiceInput!) {
    startService(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(START_SERVICE, {
    props: ({ mutate }) => ({
      startService: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelStartService})(withQuery(StartServiceFormContainer));